import { useMemo } from 'react';
import { useUserInfo } from 'marketing-platform-lib/providers/UserInfoProvider';
import useFetch from 'framework-asset-preview-lib/internal/shared/hooks/useFetch';
import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
import { fetchStatisticsForObjectType } from '../api';
export default function useFetchAssetPerformance({
  crmObject,
  nonCrmObject,
  campaignObjectId
}) {
  const {
    hasScope
  } = useUserInfo();
  const {
    typeDefinition
  } = usePreviewData();
  const useFetchProps = useMemo(() => ({
    fetcher: () => fetchStatisticsForObjectType({
      crmObject,
      nonCrmObject,
      options: {
        hasScope
      },
      campaignObjectId,
      typeDefinition
    })
  }), [crmObject, hasScope, nonCrmObject, campaignObjectId, typeDefinition]);
  return useFetch(useFetchProps);
}